import React from 'react';
import styled from 'styled-components';
import Button from '../components/Button';
import Cross from '../assets/img/xmark.svg';
import Step1Image from '../assets/img/tap-more.png';
import Step2Image from '../assets/img/got-a-voucher.png';
import Step3Image from '../assets/img/enter-code-and-redeem.png';

const CodeNotWorkingDiv = styled.div`

.close-btn {
    border: none;
    border-radius: 50%;
    width: 44px;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0;
    margin-left: auto;
} 

h1 {
    color: #2D2D2D;
    font-family: 'Speedee Bold';
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 95%;
    letter-spacing: -0.96px;
}

`;

const Step1Container = styled.div`
    display: flex;
    justify-content: space-evenly;
    margin-top: 24px;
    margin-bottom: 30px;
`;

const Step2Container = styled.div`
    display: flex;
    justify-content: space-evenly;
    margin-bottom: 30px;
    text-align: right;
`;

const Step3Container = styled.div`
    display: flex;
    justify-content: space-evenly;
    margin-bottom: 30px;
`;

const StepContent = styled.div`

    h2 {
        background-color: #FFBC0D;
        display: inline-block;
        width: 42px;
        height: 42px;
        border-radius: 100%;
        text-align: center;
        font-size: 20px;
        line-height: 40px;
        font-family: 'Speedee Bold';
        margin-bottom: 0;
    }

    p {
        font-family: 'Speedee Regular';
    }
`;

function CodeNotWorking({ ...props }) {

    
  const { setPage } = props;

  return (
    <CodeNotWorkingDiv>
        <button onClick={()=> setPage('redeem')} className="close-btn">
          <img src={Cross} alt="cross" />
        </button>
        <h1>Link not working?</h1>
        <Step1Container>
            <img src={Step1Image} alt="Open MyMaccas and tap 'More'" style={{height: "145px"}}/>
            <StepContent>
                <h2>1</h2>
                <p>Open the<br/><strong>MyMacca's app</strong><br/>and tap <strong>More</strong></p>
            </StepContent>
        </Step1Container>
        <Step2Container>
            <StepContent>
                <h2>2</h2>
                <p>Tap on<br/><strong>'Got a voucher?'</strong></p>
            </StepContent>
            <img src={Step2Image} alt="Tap 'Got a voucher?'" style={{height: "145px"}} />
        </Step2Container>
        <Step3Container>
            <img src={Step3Image} alt="Enter your code and redeem" style={{height: "145px"}}/>
            <StepContent>
                <h2>3</h2>
                <p>Enter your<br/>code and<br/><strong>redeem</strong></p>
            </StepContent>
        </Step3Container>
        <Button onClick={()=> setPage('redeem') }>Okay, got it!</Button>
      
    </CodeNotWorkingDiv>
  );
}

export default CodeNotWorking;